// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
import { listOf } from 'react-immutable-proptypes';
import FilterOperatorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { PureComponent } from 'react';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
function getReferenceLabel(reference, value) {
  if (!reference) {
    return value;
  }
  return reference.label || reference.id || reference.value;
}
function findOptionLabel(options, value) {
  const option = options && options.find(o => o.value === value);
  return option ? option.label : value;
}
export default class DisplayValueEnumeration extends PureComponent {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.handleReferenceChange = reference => {
      if (isResolved(reference)) {
        this.setState({
          reference
        });
      }
    };
    this.state = {
      reference: null
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.handleValueReference();
  }
  componentDidUpdate(prevProps) {
    const {
      value
    } = this.props;
    if (prevProps.value !== value) {
      this.handleValueReference();
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleReferenceChange);
    }
  }
  handleValueReference() {
    if (this.handleSpecialOptions()) {
      return;
    }
    this.mountResolver();
  }
  handleSpecialOptions() {
    const {
      specialOptions,
      value
    } = this.props;
    if (specialOptions) {
      const valueReference = specialOptions.findLast(reference => reference.value === value);
      if (valueReference) {
        this.setState({
          reference: valueReference
        });
        return true;
      }
    }
    return false;
  }
  mountResolver() {
    const {
      getFamilyValueResolver,
      operator,
      value
    } = this.props;
    const resolver = getFamilyValueResolver(operator);
    if (resolver && typeof resolver.byId !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'byId' function; operator.field: ${JSON.stringify(operator.field)}`));
    }
    if (resolver && resolver.byId) {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleReferenceChange);
      }
      this.referenceAtom = resolver.byId(value);
      watch(this.referenceAtom, this.handleReferenceChange);
      this.handleReferenceChange(deref(this.referenceAtom));
    }
  }
  render() {
    const {
      operator,
      value
    } = this.props;
    const {
      reference
    } = this.state;
    const valueName = reference ? getReferenceLabel(reference, value) : findOptionLabel(operator.field.options, value);
    return /*#__PURE__*/_jsx("span", {
      children: valueName
    });
  }
}
DisplayValueEnumeration.propTypes = {
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired,
  specialOptions: listOf(PropTypes.instanceOf(PropertyOptionRecord).isRequired),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};